import pusherClient from "utils/pusherClient";
import {ShipmentMessageType} from "utils/ShipmentMessageType";

/**
 * Listens to the "waybill printed" messages of one shipment.
 *
 * Returns the function that detaches this listener and drops the channel: a message
 * arriving once the caller is gone must not be delivered to it.
 */
export function subscribeToWaybillPrint(shipmentId, onMessage, client = pusherClient) {
    const channel = client.subscribe('shipment-' + shipmentId)

    channel.bind(ShipmentMessageType.WAYBILL_PRINT_MESSAGE, onMessage)

    return () => {
        channel.unbind(ShipmentMessageType.WAYBILL_PRINT_MESSAGE, onMessage)
        channel.unsubscribe()
    }
}
